import http from "../http-common";

class TempProjectFileDataService {
  getAll() {
    return http.get("/tempprojectfile");
  }

  get(id) {
    return http.get(`/tempprojectfile/${id}`);
  }

  getByProject(id) {
    return http.get(`/tempprojectfile/getByProject/${id}`);
  }

  create(data) {
    let formData = new FormData();
    //console.info("---------",data);
    formData.append("projectId", data.projectId);
		formData.append("structureName", data.structureName);
    formData.append("fileType", data.fileType);
    formData.append("file", data.file);

    console.info("---------",formData);
    return http.post("/tempprojectfile", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});

    //return http.post("/projectfile", data);
  }

  update(id, data) {
    let formData = new FormData();

    formData.append("projectId", data.projectId);
		formData.append("structureName", data.structureName);
    formData.append("fileType", data.fileType);
    formData.append("file", data.file);

    console.info("---------",formData);
    return http.put(`/tempprojectfile/${id}`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
  }

  delete(id) {
    return http.delete(`/tempprojectfile/${id}`,);
  }

  deleteAll() {
    return http.delete(`/tempprojectfile`, );
  }

  findByTitle(title) {
    return http.get(`/tempprojectfile?title=${title}`,);
  }
}

export default new TempProjectFileDataService();